seedWebApp.controller('CurrenciesController', ['$scope', '$uibModal', 'PricesService', 'TranslationService', function ($scope, $uibModal, PricesService, TranslationService) {

    $scope.translation = TranslationService.getActiveTranslation();

    //customClass: function () { return 'agp-color'; }

    $scope.storageClass = function () {
        return 'sd-storage';
    };

    $scope.columns = [
        { name: 'CurrencyID', display: $scope.translation.ID, filterOptions: [], width: 5, isKey: true },
        { name: 'CurrencyName', display: 'Moeda', filterOptions: [], width: 25 },
        { name: 'CurrencySymbol', display: 'Sigla', filterOptions: [], width: 5 },
    ];

    $scope.prefs = {
        name: 'CurrencyGrid',
        selContact: null,
        sortByCol: null,
        canAdd: false,
        canEdit: true,
        canDelete: false
    };

    //$scope.loadColumns = PricesService.getPricesColumns;
    $scope.loadService = PricesService.getCurrencies;
    $scope.resetService = PricesService.resetCache;

    $scope.loadTotal = function () {
        $scope.loadingTotal = true;
        PricesService.getCurrenciesCount().then(function (response) {
            $scope.loadingTotal = false;
            $scope.totalItems = response.data.TotalCount;
            //console.log('loadTotal');
            //console.log(response);
        });
    };

    $scope.loadTotal();

    $scope.searchMode = function () {
        $scope.$broadcast('inputSearch', $scope.filterString);
    };

    $scope.doRefresh = function () {
        $scope.$broadcast('refreshServiceGrid');
    };

    $scope.toExcel = function () {
        $scope.$broadcast('toExcel', 'Currencies');
    };

    //$scope.prefs.customEdit = function (item) {
    //    var modalInstance = $uibModal.open({
    //        templateUrl: './SPA/Prices/pricesModal.html',
    //        controller: 'PricesModalCtrl',
    //        size: 'md',
    //        resolve: {
    //            materialID: function () {
    //                return item.MaterialID;
    //            }
    //        }
    //    });
    //    modalInstance.result.then(function () {
    //        $scope.doRefresh();
    //    });
    //};

}]);